<div class="input-wrap select" [class.disabled]="disabled">
  <select
    class="input"
    [disabled]="isLoading || disabled"
    [(ngModel)]="value"
    (ngModelChange)="onValueChanged()"
  >
    <option [value]="''" [hidden]="required" selected="selected">
      {{ placeholder }}
    </option>

    <option *ngFor="let qualifier of qualifiers$ | async" [ngValue]="qualifier">
      {{ qualifier.code }} - {{ qualifier.description }}
    </option>
  </select>
</div>
